var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadTrayStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Upload-Tray--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Upload Tray Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-tray--arrow-bottom-download-internet-network,-erver-up-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.202092714285715 10.5472029C11.913610028571428 7.124194800000001 15.336644657142859 3.7011601714285716 18.759546642857142 1.9896428571428573c3.423140742857143 1.7115173142857143 6.846175371428572 5.134551942857144 8.557719214285715 8.557560042857144",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.761721985714285 23.881709742857144 0 -21.79838654142857",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.9896428571428573 26.96443585714286c0.21799588285714286 1.9310147142857144 1.0837982571428573 3.7315088571428574 2.456200842857143 5.107280571428571 1.3724291142857143 1.3760370000000002 3.1705091571428574 2.246174142857143 5.101046357142858 2.469279428571429 2.9372434285714286 0.32921957142857144 5.948607685714286 0.6093612857142857 9.023109942857143 0.6093612857142857 3.0745022571428575 0 6.088625485714286 -0.2801417142857143 9.023163 -0.6093612857142857 1.930484142857143 -0.2231052857142857 3.7285907142857146 -1.0932424285714286 5.100913714285714 -2.469279428571429 1.3725882857142857 -1.3757717142857142 2.2382155714285714 -3.1762658571428575 2.4562804285714286 -5.107280571428571",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTrayStreamlineFlex);
export default __webpack_public_path__ + "static/media/Upload-Tray--Streamline-Flex.b16d5d7ce09db6c2dc2befe8fa6bef2c.svg";
export { ForwardRef as ReactComponent };